module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Change Host")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "hostForm",
    staticClass: "hostForm",
    attrs: {
      "model": _vm.hostForm,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.loginUsername,
      "prop": "loginUsername"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "380px",
      "min-width": "100%"
    },
    attrs: {
      "multiple": "",
      "value-key": "",
      "filterable": ""
    },
    model: {
      value: (_vm.hostForm.loginUsername),
      callback: function($$v) {
        _vm.hostForm.loginUsername = $$v
      },
      expression: "hostForm.loginUsername"
    }
  }, _vm._l((_vm.connects), function(item, index) {
    return _c('el-option', {
      key: index,
      staticStyle: {
        "width": "380px",
        "min-width": "100%"
      },
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.hostForm.loginUsername.length
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbe7d4a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/workgroup-change-host.vue
// module id = 620
// module chunks = 4 5 6